import React from "react";
import { Box, Typography, Divider, Button, useTheme } from "@mui/material";

export default function BudgetAnalysisViewer({ response }) {
    const theme = useTheme();
    const primary = theme.palette.primary.main;
    const textColor = theme.palette.text.primary;

    const logoUrl =
        "https://figk-12.com/static/media/fig_CROP.cb0d7cf4314c63ba05ee.png";

    // Split into sections on newline preceding �1) �, �2) �, etc.
    const sections = response
        .split(/\n(?=\d\)\s)/)
        .map((s) => s.trim())
        .filter(Boolean);

    const handlePrint = () => {
        const html = document.getElementById("budget-analysis-report")?.innerHTML;
        if (!html) return alert("No report available to print.");
        const backup = document.body.innerHTML;
        document.body.innerHTML = html;
        window.print();
        document.body.innerHTML = backup;
    };

    return (
        <Box
            id="budget-analysis-report"
            sx={{
                backgroundColor: "#f8f9fa",
                padding: 4,
                borderRadius: 2,
                maxWidth: 800,
                margin: "0 auto",
                boxShadow: 2,
            }}
        >
            {/* Header with logo and print */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                }}
            >
                <Box
                    component="img"
                    src={logoUrl}
                    alt="FIG Logo"
                    sx={{ width: 100, height: 100, objectFit: "cover" }}
                />
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: primary,
                        color: "#fff",
                        "&:hover": { backgroundColor: theme.palette.primary.dark },
                    }}
                    onClick={handlePrint}
                >
                    Print Report
                </Button>
            </Box>

            {/* Numbered sections */}
            {sections.map((sec, idx) => {
                const [headerLine, ...bodyLines] = sec.split("\n");
                const bodyText = bodyLines.join("\n").trim();
                const paragraphs = bodyText.split(/\n{2,}/).map((p) => p.trim());

                return (
                    <Box key={idx} sx={{ mb: 4 }}>
                        {/* Colored header bar */}
                        <Box
                            sx={{
                                bgcolor: primary,
                                color: "#fff",
                                px: 2,
                                py: 1,
                                borderRadius: 1,
                                mb: 1,
                            }}
                        >
                            <Typography variant="h6">{headerLine}</Typography>
                        </Box>

                        {/* Body paragraphs */}
                        {paragraphs.map((p, pi) => (
                            <Typography
                                key={pi}
                                paragraph
                                sx={{ color: textColor, lineHeight: 1.6 }}
                            >
                                {p}
                            </Typography>
                        ))}

                        {/* Divider except after last */}
                        {idx < sections.length - 1 && <Divider sx={{ my: 2 }} />}
                    </Box>
                );
            })}
        </Box>
    );
}
